import { defineStore } from 'pinia';
import { ref } from 'vue';

import { SlideStudioPageItem } from '@/types';

export const usePptxStore = defineStore('pptx', () => {
    const requirementsFulfilled = ref<boolean>(false);

    const slideStudioSelectedThemeId = ref<string>('');
    const slideStudioSelectedSlide = ref<SlideStudioPageItem | null>(null);

    const slideStudioSetCurrentSelectedSlide = (
        value: SlideStudioPageItem | null
    ) => {
        slideStudioSelectedSlide.value = value;
    };
    const slideStudioResetCurrentSelectedSlide = () => {
        slideStudioSelectedSlide.value = null;
    };
    const slideStudioSetSelectedThemeId = (value: string) => {
        slideStudioSelectedThemeId.value = value;
    };
    const slideStudioResetSelectedThemeId = () => {
        slideStudioSelectedThemeId.value = '';
    };

    const setRequirementsFulfilled = (value: boolean) => {
        requirementsFulfilled.value = value;
    };

    const pendingChatSessionId = ref<string | null>(null);

    const setPendingChatSessionId = (value: string) => {
        pendingChatSessionId.value = value;
    };
    const resetPendingChatSessionId = () => {
        pendingChatSessionId.value = null;
    };

    return {
        //State
        requirementsFulfilled,
        slideStudioSelectedThemeId,
        slideStudioSelectedSlide,
        pendingChatSessionId,
        //Actions
        setRequirementsFulfilled,
        setPendingChatSessionId,
        resetPendingChatSessionId,
        slideStudioSetSelectedThemeId,
        slideStudioResetSelectedThemeId,
        slideStudioSetCurrentSelectedSlide,
        slideStudioResetCurrentSelectedSlide
    };
});
